import { useQuery } from "@tanstack/react-query"
import api2 from "~/api2"
import { queryKeys } from "~/constants/queryKeys"

type Props = {
  orderId?: string
}

export const useOrderInvoice = (props: Props) => {
  return useQuery({
    queryKey: [queryKeys.ORDER_INVOICE, props.orderId],
    queryFn: () => fetchOrderInvoice(props.orderId),
    enabled: !!props.orderId,
    retry: false,
    gcTime: 2000,
  })
}

export const fetchOrderInvoice = async (orderId?: string) => {
  if (!orderId) return
  try {
    const response = await api2.Invoices.fetchForOrder(orderId)
    return response?.invoice
  } catch (error) {
    console.error("Error fetching order invoice:", error)
    throw error
  }
}
